import {
    SET_SWITCH_PURPOSES,
    SET_SWITCH_VENDORS,
    SET_SWITCH_CUSTOM,
    ADD_SWITCH_PURPOSE,
    REMOVE_SWITCH_PURPOSE,
    ADD_SWITCH_VENDOR,
    REMOVE_SWITCH_VENDOR,
    ADD_SWITCH_CUSTOM,
    REMOVE_SWITCH_CUSTOM
} from "../action_types";

const switchesReducer = (switches = {}, action) => {
    switch (action.type) {
        case SET_SWITCH_PURPOSES:
            return Object.assign({}, switches, { purposes: action.purposes });

        case SET_SWITCH_VENDORS:
            return Object.assign({}, switches, { vendors: action.vendors });

        case SET_SWITCH_CUSTOM:
            return Object.assign({}, switches, { custom: action.custom });

        case ADD_SWITCH_PURPOSE: {
            let arr = [...switches.purposes];
            let curSwitch = arr.find(e => e.id === action.id);
            curSwitch.isOn = true;
            return Object.assign({}, switches, { purposes: arr });
        }

        case REMOVE_SWITCH_PURPOSE: {
            let arr = [...switches.purposes];
            let curSwitch = arr.find(e => e.id === action.id);
            curSwitch.isOn = false;
            return Object.assign({}, switches, { purposes: arr });
        }

        case ADD_SWITCH_VENDOR:{
            let arr = [...switches.vendors];
            let curSwitch = arr.find(e => e.id === action.id);
            curSwitch.isOn = true;
            return Object.assign({}, switches, { vendors: arr });
        }

        case REMOVE_SWITCH_VENDOR:{
            let arr = [...switches.vendors];
            let curSwitch = arr.find(e => e.id === action.id);
            curSwitch.isOn = false;
            return Object.assign({}, switches, { vendors: arr });
        }

        case ADD_SWITCH_CUSTOM: {
            let arr = [...switches.custom];
            let curSwitch = arr.find(e => e.id === action.id);
            curSwitch.isOn = true;
            return Object.assign({}, switches, { custom: arr });
        }

        case REMOVE_SWITCH_CUSTOM: {
            let arr = [...switches.custom];
            let curSwitch = arr.find(e => e.id === action.id);
            curSwitch.isOn = false;
            return Object.assign({}, switches, { custom: arr });
        }

        default:
            return switches;
    };
};

export default switchesReducer;